<template>
<div class="containers">
    <div class="search-area">
        <CRow class="no-gutters">
            <CCol style="padding-right:4px" sm="2">
                <div class="autocomplete">
                    <input type="text"
                            class="form-control"
                            @click="toggleVisiblePegawai()"
                            @blur="toggleCloseVisiblePegawai()"
                            v-model="queryPegawai"
                            v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                            @keydown.up="upPegawai"
                            @keydown.down="downPegawai"
                            @keydown.enter="selectItemPegawai"
                            placeholder="Pilih Pegawai"
                    >
                    <div class="popovers" v-show="visiblePegawai">
                        <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                            <ul>
                            <li v-for="(match, index) in matchesPegawai"
                                :key="index"
                                :class="{ 'selected': (selectedPegawai == index)}"
                                @click="itemClickedPegawai(index)"
                                v-text="match['text']"></li>
                            </ul>
                        </div>
                        <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">
                            Data Tidak Ditemukan
                        </div>
                        <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">
                            Start Typing...
                        </div>
                    </div>
                </div>
            </CCol>
            <CCol style="padding-right:4px;padding-left:4px" sm="2">
                <div class="autocomplete">
                    <input type="text"
                            class="form-control"
                            @click="toggleVisibleUnit()"
                            @blur="toggleCloseVisibleUnit()"
                            v-text="selectedItemUnit ? selectedItemUnit['text'] : ''"
                            v-model="queryUnit"
                            @keydown.up="upUnit"
                            @keydown.down="downUnit"
                            @keydown.enter="selectItemUnit"
                            placeholder="Pilih Unit Level"
                    >
                    <div class="popovers" v-show="visibleUnit">
                        <div class="options" v-if="matchesUnit.length != 0 && queryUnit.length != 0" ref="optionsList">
                            <ul>
                            <li v-for="(match, index) in matchesUnit"
                                :key="index"
                                :class="{ 'selected': (selectedUnit == index)}"
                                @click="itemClickedUnit(index)"
                                v-text="match['text']"></li>
                            </ul>
                        </div>
                        <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length != 0">
                            Data Tidak Ditemukan
                        </div>
                        <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length == 0">
                            Start Typing...
                        </div>
                    </div>
                </div>
            </CCol>
            <CCol style="padding-right:4px;padding-left:4px" sm="2">
                <input type="text" class="form-control" placeholder="Judul" v-model="searchValue"/>
            </CCol>
            <CCol style="padding-right:4px;padding-left:4px" sm="2">
                <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" placeholder="Tanggal Mulai" v-model="tanggalMulai" class="form-control"/>
            </CCol>
            <CCol style="padding-right:4px;padding-left:4px" sm="2">
                <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" placeholder="Tanggal Selesai" v-model="tanggalSelesai" class="form-control"/>
            </CCol>
            <CCol style="padding-left:6px" sm="2">
                <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
            </CCol>
        </CRow>
    </div>
    <div class="sticky1">
        <CRow>
            <CCol sm="6">
                <img class="mr-4 mt-1" v-if="datas.length != 0" @click="getDownload()" style="float:left;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
            </CCol>
            <CCol sm="6">
                <span style="float:right">
                    <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                </span>
                <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
            </CCol>
        </CRow>
    </div>
    <Tables @sort="sorting" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
</div>
</template>

<script>
import Tables from '../component/tableReport'
import {DataApi} from "../service/DataApi";
import { ModelSelect } from 'vue-search-select'

export default {
    components: {
        ModelSelect,
        Tables
    },
    data() {
        return {
            // data search pegawai
            dataPegawai: [],
            titlePegawai:"Pilih Pegawai",
            selectedItemPegawai: null,
            selectedPegawai: 0,
            queryPegawai: '',
            visiblePegawai: false,

            // data search unit
            dataUnit: [],
            titleUnit:"Pilih Unit Level",
            selectedItemUnit: null,
            selectedUnit: 0,
            queryUnit: '',
            visibleUnit: false,
            idUnits: '',

            // datas
            refreshIcon: require('../assets/menu/icon_refresh.svg'),
            moreIcon: require('../assets/menu/icon_more.svg'),
            downloadIcon: require('../assets/menu/icon_download_excel.svg'),
            dataTh: ['Nama', 'Judul', 'Tanggal', 'Jam', 'Peserta', 'Keterangan', 'File'],
            dataTd: [['urlFoto', 'nama'], 'judul', 'tglReport', 'jam', 'fotoPeserta', 'keterangan', 'urlFile'],
            styleTable: ['100px', '70px', '50px', '50px', '100px', '100px', '30px' ],
            classReload: 'reloadOff',
            datas: [],
            dataBulan: [],

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            searchValue: '',
            tanggalMulai: '',
            tanggalSelesai: '',
            date: {
                from: null,
                to: null,
                month: null,
                monthIndex: null,
                year: null
            },
            tanggal: new Date(),
            dataYear: [],

            // error
            errorMessage: '', 
            flagSearch: false           
        }
    },
    computed: {
        matchesPegawai() {
            if (this.queryPegawai == '') {
                return [];
            }
            return this.dataPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryPegawai.toLowerCase()))
        },
        matchesUnit() {
            if (this.queryUnit == '') {
                return [];
            }
            return this.dataUnit.filter((item) => item['text'].toLowerCase().includes(this.queryUnit.toLowerCase()))
        },
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        searchValue() {
            this.flagSearch = true
        },
        queryPegawai() {
            this.flagSearch = true
            this.getDataPegawai()
        },
        queryUnit() {
            this.flagSearch = true
            this.getDataUnit()
        },
        tanggalMulai() {
            this.flagSearch = true
        },
        tanggalSelesai() {
            this.flagSearch = true
        }
    },
    methods: {
        /**
         * SEARCH PEGAWAI
         */
        getDataPegawai() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 10,
                nama: this.queryPegawai,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].nik,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPegawai.push(onPush)
                }
            })
        },

        toggleVisiblePegawai() {
            this.visiblePegawai = true;
        },
        hidePegawai() {
            this.visiblePegawai = false;
        },
        toggleCloseVisiblePegawai() {
            setTimeout(this.hidePegawai, 1000);
        },
        itemClickedPegawai(index) {
            this.selectedPegawai = index;
            this.selectItemPegawai();
        },
        selectItemPegawai() {
            if (!this.matchesPegawai.length) {
            return;
            }
            this.selectedItemPegawai = this.matchesPegawai[this.selectedPegawai];
            this.visiblePegawai = false;
            this.queryPegawai = this.selectedItemPegawai.text
            if (this.shouldReset) {
            this.queryPegawai = '';
            this.selectedPegawai = 0;
            }
        },
        upPegawai() {
            if (this.selectedPegawai == 0) {
            return;
            }
            this.selectedPegawai -= 1;
            this.scrollToItemPegawai();
        },
        downPegawai() {
            if (this.selectedPegawai >= this.matchesPegawai.length - 1) {
            return;
            }
            this.selectedPegawai += 1;
            this.scrollToItemPegawai();
        },
        scrollToItemPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedPegawai * this.itemHeight;
        },
        //

        /**
         * SEARCH UNIT LEVEL
         */
        getDataUnit() {
            let payload = {
                limit: 10,
                namaUnit: this.queryUnit,
                pageIn: 1,
                namaParentUnit: '',
                idUnit: ''
            }
            DataApi.post("unit/get", payload)
            .then(res => {
                this.dataUnit = []
                let response = res.data.data
                let tempData = response.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = ''
                    if(tempData[i].parentBidang == null || tempData[i].parentBidang == 'null') {
                        onPush = {
                            value: tempData[i].id,
                            text: tempData[i].bidang
                        }                      
                    } else {
                        onPush = {
                            value: tempData[i].id,
                            text: tempData[i].bidang + ' - ' + tempData[i].parentBidang                            
                        }
                    }
                    this.dataUnit.push(onPush)
                }
            })
        },

        toggleVisibleUnit() {
            this.visibleUnit = true;
        },
        hideUnit() {
            this.visibleUnit = false;
        },
        toggleCloseVisibleUnit() {
            setTimeout(this.hideUnit, 1000);
        },
        itemClickedUnit(index) {
            this.selectedUnit = index;
            this.selectItemUnit();
        },
        selectItemUnit() {
            if (!this.matchesUnit.length) {
            return;
            }
            this.selectedItemUnit = this.matchesUnit[this.selectedUnit];
            this.queryUnit = this.selectedItemUnit.text
            this.idUnits = this.selectedItemUnit.value
            this.visibleUnit = false;
            if (this.shouldReset) {
            this.queryUnit = '';
            this.selectedUnit = 0;
            }
        },
        upUnit() {
            if (this.selectedUnit == 0) {
            return;
            }
            this.selectedUnit -= 1;
            this.scrollToItemUnit();
        },
        downUnit() {
            if (this.selectedUnit >= this.matchesUnit.length - 1) {
            return;
            }
            this.selectedUnit += 1;
            this.scrollToItemUnit();
        },
        scrollToItemUnit() {
            this.$refs.optionsList.scrollTop = this.selectedUnit * this.itemHeight;
        },


        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
                        return -1
                    }
                    if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.nik.toLowerCase() < b.nik.toLowerCase()) {
                        return -1
                    }
                    if (a.nik.toLowerCase() > b.nik.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.polaAbsensi.toLowerCase() < b.polaAbsensi.toLowerCase()) {
                        return -1
                    }
                    if (a.polaAbsensi.toLowerCase() > b.polaAbsensi.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 3) {
                function compare(a,b) {
                    if (a.wfh.toLowerCase() < b.wfh.toLowerCase()) {
                        return -1
                    }
                    if (a.wfh.toLowerCase() > b.wfh.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 4) {
                function compare(a,b) {
                    if (a.wfo.toLowerCase() < b.wfo.toLowerCase()) {
                        return -1
                    }
                    if (a.wfo.toLowerCase() > b.wfo.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 5) {
                function compare(a,b) {
                    if (a.mangkir.toLowerCase() < b.mangkir.toLowerCase()) {
                        return -1
                    }
                    if (a.mangkir.toLowerCase() > b.mangkir.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 6) {
                function compare(a,b) {
                    if (a.dinas.toLowerCase() < b.dinas.toLowerCase()) {
                        return -1
                    }
                    if (a.dinas.toLowerCase() > b.dinas.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 7) {
                function compare(a,b) {
                    if (a.cuti.toLowerCase() < b.cuti.toLowerCase()) {
                        return -1
                    }
                    if (a.cuti.toLowerCase() > b.cuti.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 8) {
                function compare(a,b) {
                    if (a.sakit.toLowerCase() < b.sakit.toLowerCase()) {
                        return -1
                    }
                    if (a.sakit.toLowerCase() > b.sakit.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 9) {
                function compare(a,b) {
                    if (a.ijin.toLowerCase() < b.ijin.toLowerCase()) {
                        return -1
                    }
                    if (a.ijin.toLowerCase() > b.ijin.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 10) {
                function compare(a,b) {
                    if (a.nsi.toLowerCase() < b.nsi.toLowerCase()) {
                        return -1
                    }
                    if (a.nsi.toLowerCase() > b.nsi.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 11) {
                function compare(a,b) {
                    if (a.nso.toLowerCase() < b.nso.toLowerCase()) {
                        return -1
                    }
                    if (a.nso.toLowerCase() > b.nso.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 12) {
                function compare(a,b) {
                    if (a.telat.toLowerCase() < b.telat.toLowerCase()) {
                        return -1
                    }
                    if (a.telat.toLowerCase() > b.telat.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 13) {
                function compare(a,b) {
                    if (a.cepet.toLowerCase() < b.cepet.toLowerCase()) {
                        return -1
                    }
                    if (a.cepet.toLowerCase() > b.cepet.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 14) {
                function compare(a,b) {
                    if (a.lembur.toLowerCase() < b.lembur.toLowerCase()) {
                        return -1
                    }
                    if (a.lembur.toLowerCase() > b.lembur.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 15) {
                function compare(a,b) {
                    if (a.hariKerjaKalender.toLowerCase() < b.hariKerjaKalender.toLowerCase()) {
                        return -1
                    }
                    if (a.hariKerjaKalender.toLowerCase() > b.hariKerjaKalender.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 16) {
                function compare(a,b) {
                    if (a.hariKerjaPegawai.toLowerCase() < b.hariKerjaPegawai.toLowerCase()) {
                        return -1
                    }
                    if (a.hariKerjaPegawai.toLowerCase() > b.hariKerjaPegawai.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getDownload() {
            if(this.datas.length != 0) {
                let nik = ''
                if(this.queryPegawai.split(" - ")[1] == undefined) {
                    nik = ''
                } else {
                    nik = this.queryPegawai.split(" - ")[1]
                }
                if(this.queryUnit == '') {
                    this.idUnits = ''
                }
                let unit = ''
                if(this.queryUnit == '') {
                    unit = ''
                } else {
                    unit = this.idUnits
                }
                let payload = {
                    judul: this.searchValue,
                    limit: this.totalRow,
                    lvl: unit,
                    nama: this.queryPegawai.split(" - ")[0],
                    nik: nik,
                    pageIn: 1,
                    tglMulai: this.tanggalMulai,
                    tglSelesai: this.tanggalSelesai
                }
                DataApi.post("/export/report/lihat/backoffice", payload , {responseType: 'blob'})
                .then(res => {
                    let response = res.data
                    // let fileName = res.headers["content-disposition"].split("filename=")[1];
                    const url = URL.createObjectURL(new Blob([response], {
                        type: 'application/vnd.ms-excel'
                    }))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'Team Report')
                    document.body.appendChild(link)
                    link.click()
                })
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let nik = ''
            if(this.queryPegawai.split(" - ")[1] == undefined) {
                nik = ''
            } else {
                nik = this.queryPegawai.split(" - ")[1]
            }
            if(this.queryUnit == '') {
                this.idUnits = ''
            }
            let unit = ''
            if(this.queryUnit == '') {
                unit = ''
            } else {
                unit = this.idUnits
            }
            let payload = {
                judul: this.searchValue,
                limit: this.size,
                lvl: unit,
                nama: this.queryPegawai.split(" - ")[0],
                nik: nik,
                pageIn: this.page,
                tglMulai: this.tanggalMulai,
                tglSelesai: this.tanggalSelesai
            }
            DataApi.post("report/lihat/backoffice", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        setDate() {
            let month = this.tanggal.getMonth() + 1
            let year = this.tanggal.getFullYear()
            this.date.monthIndex = month
            this.date.year = year
        },
        findData() {
            this.getData()
        },
        reload() {
            this.searchValue = ''
            this.queryPegawai = ''
            this.queryUnit = ''
            this.idUnits = ''
            this.tanggalMulai = ''
            this.tanggalSelesai = ''
            this.flagSearch = true
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
            this.getData()
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        showDate(date) {
            this.date = date
        }
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataPegawai()
        this.getDataUnit()
        this.setDate()
    }
}
</script>
<style scoped>
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.nowraps {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.card-title {
    font-size: 14px;
    font-weight: 600;
    color: rgba(16, 16, 16, 1);
}
.card-subtitle {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
}
.card-emblem {
    float:right;
    background-color:rgba(48, 107, 221, 0.05);
    text-align: center;
    line-height: 32px;
    min-width:40px;
    min-height:40px;
    border-radius:50%;
}
input[type="checkbox"] {
    width: 16px;
    height: 16px;
    margin-right: 8px;
}
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
@media screen and (min-width: 1253px) and (max-width: 1358px) {
    .inputs-form {
        float:left;
        width:52%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1168px) and (max-width: 1252px) {
    .inputs-form {
        float:left;
        width:47%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1097px) and (max-width: 1167px) {
    .inputs-form {
        float:left;
        width:42%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1036px) and (max-width: 1096px) {
    .inputs-form {
        float:left;
        width:37%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 992px) and (max-width: 1035px) {
    .inputs-form {
        float:left;
        width:32%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1359px){
    .inputs-form {
        float:left;
        width:57%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
.btn-search {
    border-radius: 4px;
    float: right;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    float: right;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(360deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(0deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 12px;
    padding-right: 24px;
    padding-left: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

</style>